<div class="container">
  <div class="row">
    <div class="col-lg-10 mx-auto">
      <div class="bg-white rounded-4 p-4">
        <h2 class="text-primary fw-500 mb-2">Get started With Treasure Hill</h2>
        <p class="text-muted">Please fill the one time registration form to get started.</p>
        <hr class="text-muted" />
        <!-- Public app: reCAPTCHA enabled (default behavior) -->
        <prospect-form
          [isPublic]="'public'"
          [enableRecaptcha]="true"
          [enableCardScan]="false"
          [selectedSalesOfficeInput]="salesOfficeId()"
          [onSubmit]="onSubmitButtonClickObservable"
        ></prospect-form>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button
            class="btn btn-shadow text-center btn-h45 btn-prosp-submit justify-content-center"
            [routerLink]="['/new', salesOfficeId(), 'public']"
          >
            Back
          </button>
          <button
            class="btn btn-primary text-center btn-h45 btn-prosp-submit justify-content-center"
            (click)="onSaveButtonClick()"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
